export function ViewGridIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.00012 0C0.895553 0 0.00012207 0.89543 0.00012207 2V4C0.00012207 5.10457 0.895553 6 2.00012 6H4.00012C5.10469 6 6.00012 5.10457 6.00012 4V2C6.00012 0.895431 5.10469 0 4.00012 0H2.00012Z'
        fill='currentColor'
      />
      <path
        d='M2.00012 8C0.895553 8 0.00012207 8.89543 0.00012207 10V12C0.00012207 13.1046 0.895553 14 2.00012 14H4.00012C5.10469 14 6.00012 13.1046 6.00012 12V10C6.00012 8.89543 5.10469 8 4.00012 8H2.00012Z'
        fill='currentColor'
      />
      <path
        d='M8.00012 2C8.00012 0.89543 8.89555 0 10.0001 0H12.0001C13.1047 0 14.0001 0.895431 14.0001 2V4C14.0001 5.10457 13.1047 6 12.0001 6H10.0001C8.89555 6 8.00012 5.10457 8.00012 4V2Z'
        fill='currentColor'
      />
      <path
        d='M8.00012 10C8.00012 8.89543 8.89555 8 10.0001 8H12.0001C13.1047 8 14.0001 8.89543 14.0001 10V12C14.0001 13.1046 13.1047 14 12.0001 14H10.0001C8.89555 14 8.00012 13.1046 8.00012 12V10Z'
        fill='currentColor'
      />
    </svg>
  )
}
